import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import { type DentalStepParams, earnsAboveThresholdSchema } from './types'

export const earnsAboveThreshold = (params: DentalStepParams) =>
  ({
    schema: earnsAboveThresholdSchema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_earns_above_threshold.title',
        },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('earns_above_threshold'),
      },
      {
        type: 'infoBox',
        showInfoIcon: true,
        contentConfiguration: [
          {
            type: 'title',
            size: 'h5',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_dental:steps.dental_earns_above_threshold.info.title',
            },
          },
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_dental:steps.dental_earns_above_threshold.info.text',
            },
          },
        ],
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('earns_above_threshold'),
      valueToStepName: {
        true: 'login',
        // TODO: https://hellogetsafe.atlassian.net/browse/IA-1318
        // Since the web dose not accommodate the implementation of the customButton, we created a separate step for the web.
        // This is a temporary solution for now.
        false: params.platform === 'web' ? 'redirect_to_allianz_web' : 'redirect_to_allianz',
      },
    },
    subFlow: SubFlow.Dental,
  }) as const satisfies AnyStepConfiguration
